export const isAdmin = (name) => {
  const  adminsList = ['superadmin',  'admin'];
  return adminsList.includes(name);
};
